export enum MatchStatus {
  // only match stats api called
  fixture ='Fixture', 
  suspended = 'Suspended', 
  // both match stats and match events called
  playing = 'Playing',
  // both opta calls stopped
  played = 'Played',
  cancelled = 'Cancelled',
  postponed = 'Postponed',
  awarded = 'Awarded',
} 